// Valeurs prédéfinies pour les activités
export const ACTIVITIES_OPTIONS = [
  "Karting",
  "Bowling",
  "Laser Game",
  "Prison Island",
  "Karaoké",
  "Billard",
  "Quizz Team",
  "Blind Test",
  "Drift Bike",
  "Tampoline",
  "Fléchettes",
  "Arcades",
];

// Valeurs prédéfinies pour les extras (Smile World + Laser World fusionnés)
export const EXTRAS_OPTIONS = [
  // Smile World
  "Offre de restauration",
  "Offre de bar",
  "Privatisation semi-complète",
  "Privatisation complète",
  // Laser World
  "Boissons Soft",
  "Formule Apéritive",
  "Buffet Traiteur",
  "Pizzas",
  "Soirée Dansante",
  "Remise de coupe & médailles",
  "Photos & vidéos",
];
